//// Facilitates the ladda button loading indicators.
//// Any element meeting the following conditions will be automatically registered
//// as a WaitButton if the behavior is included in a view:
//// * It's a button element.
//// * It's declared in the view's ui object
//// * It has the "ladda-button" class.
//// Currently somewhat integrated with the saveModelBehavior.
//// There are times when we need a wait button indicator to spin while
//// multiple promises resolve, interspersed with additional client logic.
//// In those cases, the view can manually, directly trigger the showWaiting and doneWaiting events.
const Marionette = require('backbone.marionette'),
    Ladda = require('ladda');

module.exports = Marionette.Behavior.extend({
    initialize: function() {
        this.view.waitOn = function(promise, e) {
            this.triggerMethod('showWaiting', e);
            promise.always(function() {
                this.triggerMethod('doneWaiting', e);
            }.bind(this));
            return promise;
        };
    },
    onRender: function() {
        // Apparently, sometimes this gets called multiple times, and on those
        // subsequent calls, this.view.ui is undefined.
        if (!this.view.ui) {
            return;
        }
        this.laddaButtons = {};
        // Holds list of raw js objects from the view.ui object properties.
        let uiList = [];
        let viewUiEntries = Object.entries(this.view.ui);
        if (viewUiEntries) {
            viewUiEntries.forEach((prop) => {
                // First element is always the string key, so we always want to push the actual element.
                _.forEach(prop[1], (p) => {
                    uiList.push(p);
                });
            });
        }
        _.forEach(uiList, (item) => {
            if (item.nodeName.toLowerCase() === 'button' && _.includes(item.classList, 'ladda-button')) {
                let selector = this.getSelector(item);
                if (selector) {
                    this.laddaButtons[selector] = Ladda.create(item);
                }
            }
        });
    },
    onShowWaiting: function(e) {
        let selector = this.getSelector(e);
        let button = this.laddaButtons[selector];
        if (button) {
            button.start();
        }
    },
    onDoneWaiting: function(e) {
        let selector = this.getSelector(e);
        let button = this.laddaButtons[selector];
        if (button) {
            button.stop();
        }
    },
    //// Finds the id from the correct object, given a few distinct scenarios.
    getSelector: function(e) {
        let button = null;
        // This aims to get the correct object having the id when no event has
        // been triggered (ie. when the behavior is first setting up, on render).
        if (!e.currentTarget && !e.target) {
            button = e;
        }
        else {
            // If we are here because of an event (ie. from onShowWaiting() or
            // onDoneWaiting()), we again need to discern the correct object that
            // has the id. Apparently, there are times that you can trigger a
            // click event from jQuery, and e.currentTarget will be 'Window'.
            // In that event, e.target will still correspond to the proper element.
            button = !e.currentTarget.id ? e.target : e.currentTarget;
        }
        if (!button) {
            return;
        }
        let selector = !button.id ? null : button.id;
        return selector;
    }
    // The above function is a tad superfluous, right now.
    // The whole reason it exists was to allow us to use either id or a specific
    // class name (ie. "id-save") as the selector. Using class names would mean not
    // needing separate button id's for things like a desktop and mobile save button.
    // The special classname was to indicate that the class was being used like an id.
    // This function had a regex that would return the proper class name as selector
    // if the id was null. But it doesn't seem like ladda (or ladda+marionette) will
    // allow multiple buttons to be targeted with the same start()/stop() function calls.
    // If anyone ever wants to try to figure out how to make that work, then reinstating the regex,
    // here, and then changing the markup on the specific controls to use the proper classname syntax,
    // instead of an id, should be all that's needed to get this behavior to continue to work properly
    // while also requiring no config.
});
